import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import UserContext from '../../../contexts/UserContext';
import { Tab, TabProps, Dimmer, Loader, Button, Dropdown, Checkbox, Icon, Input } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { listCommunities } from '../../../services/community';
import Menu from '../../components/Menu';

import './style.less';
import DailyActivities from '../../components/DailyActivities';

const CommunityActivities = ({ history }) => {
    // const {
    //     userObject: {
    //         registrants: { list: listOfResidents, activeRegistrantsIndexes },
    //     },
    // } = useContext(UserContext);
    const userContext = useContext(UserContext);
    console.log('uC', userContext);
    const communityId = history.location.pathname.split('/').pop();

    return (
        <div className="relative-list food-menu">
            <DailyActivities />
        </div>
    );
};

export default CommunityActivities;
